export interface Bucket {
  bucketStart: string;
  users: number;
  visits: number;
}

export interface UsageRow {
  key: string;
  label: string;
  appName?: string;
  users: number;
  visits: number;
  buckets: Bucket[];
}

/**
 * The columns the app-usage table draws.
 *
 * Built from the range the server reports (`bucketStarts`) rather than from the
 * buckets that happened to come back with data. An aggregation only emits
 * buckets that hold events, so deriving the columns from the rows alone makes a
 * zero-activity day disappear from the axis instead of showing as an empty
 * column — and a table whose columns silently change shape is worse than one
 * with a gap in it.
 *
 * Row buckets are unioned in as well, so nothing renders nowhere if the two ever
 * disagree — including against a server old enough not to send `bucketStarts`.
 *
 * ISO-8601 UTC strings sort lexicographically in chronological order, which is
 * what the server sends.
 */
export const resolveBucketColumns = (
  rangeBuckets: string[] | undefined,
  rows: UsageRow[] | undefined
): string[] => {
  const seen = new Set<string>(Array.isArray(rangeBuckets) ? rangeBuckets : []);
  for (const row of Array.isArray(rows) ? rows : []) {
    for (const bucket of row.buckets || []) seen.add(bucket.bucketStart);
  }
  return Array.from(seen).sort();
};
